<template>
<div>
    <div class="form-row">
        <div class="col">
            <form-input label="Pay Group Name" v-model="formData.name" :errors="errors.name" type="text" :maxlength="128" />
        </div>
    </div>

    <div class="form-row">
        <div class="col">
            <form-input label="Frequency" v-model="formData.pay_schedule" :errors="errors.pay_schedule" type="select" :options="payScheduleOptions" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-6">
            <form-input label="Pay Period Start" v-model="formData.period_start" :errors="errors.period_start" type="select" :options="payPeriodStartOptions" />
        </div>

        <div class="col-6" v-if="this.formData.pay_schedule == 'semi-monthly'">
            <form-input label="Pay Period End" v-model="formData.period_end" :errors="errors.period_end" type="select" :options="payPeriodEndOptions" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-6">
            <form-input :label="firstCheckDateLabel"  helper-text="(Days after pay period)" v-model="formData.check_date_offset_1" :errors="errors.check_date_offset_1" type="integer" />
        </div>

        <div class="col-6" v-if="this.formData.pay_schedule == 'semi-monthly'">
            <form-input label="Second Check Date Offset" helper-text="(Days after pay period)" v-model="formData.check_date_offset_2" :errors="errors.check_date_offset_2" type="integer" />
        </div>
    </div>

    <div class="form-row">
        <div class="col-6">
            <form-input label="Banking Holiday Treatment" v-model="formData.bank_holiday_treatment" :errors="errors.bank_holiday_treatment" type="select" :options="bankHolidayTreatmentOptionsOptions" />
        </div>

        <div class="col-6" v-if="['semi-monthly', 'monthly'].includes(this.formData.pay_schedule)">
            <form-input label="Weekend Treatment" v-model="formData.weekend_treatment" :errors="errors.weekend_treatment" type="select" :options="weekendTreatmentOptionsOptions" />
        </div>
    </div>


    <form-errors :errors="formErrors" />
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'

function numerize(i) {
    const s = ('' + i).trim().slice(-1)

    if (!s) {return ''}

    const endings = {
        1: 'st',
        2: 'nd',
        3: 'rd',
    }

    const ending = endings.hasOwnProperty(s) ? endings[s] : 'th'
    return i + ending
}

export default {
    props: ['initialValue', ],
    mixins: [FormMixin, ],
    computed: {
        payScheduleOptions() {
            return [
                {text: 'Weekly', value: 'weekly'},
                {text: 'Bi-weekly', value: 'bi-weekly'},
                {text: 'Semi-monthly', value: 'semi-monthly'},
                {text: 'Monthly', value: 'monthly'},
            ]
        },
        payPeriodStartOptions() {
            if (['weekly', 'bi-weekly'].includes(this.formData.pay_schedule)) {
                return [
                    {text: 'Monday', value: 0},
                    {text: 'Tuesday', value: 1},
                    {text: 'Wednesday', value: 2},
                    {text: 'Thursday', value: 3},
                    {text: 'Friday', value: 4},
                    {text: 'Saturday', value: 5},
                    {text: 'Sunday', value: 6},
                ]
            }

            if (['monthly', 'semi-monthly'].includes(this.formData.pay_schedule)) {
                const result = []
                for (let i = 1; i <= 27; i++) {
                    result.push({text: numerize(i), value: i})
                }

                result.push({text: 'End of the Month', value: 32})

                return result
            }
        },
        payPeriodEndOptions() {
            return this.payPeriodStartOptions
        },
        bankHolidayTreatmentOptionsOptions() {
            return [
                {value: 'one-day-forward', text: 'Move one banking day forward'},
                {value: 'one-day-backward', text: 'Move one banking day backward'},
                {value: 'closest', text: 'Move to closest business day'},
                {value: 'no-change', text: 'No change'},
            ]
        },
        weekendTreatmentOptionsOptions() {
            return this.bankHolidayTreatmentOptionsOptions
        },
        firstCheckDateLabel() {
            return this.formData.pay_schedule == 'semi-monthly' ? 'First Check Date Offset' : 'Check Date Offset'
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            formRules: {
                name: {presence: {allowEmpty: false}, },
                pay_schedule: {presence: {allowEmpty: false}, },
                period_start: {presence: {allowEmpty: false}, },
                check_date_offset_1: {presence: {allowEmpty: false}, },
                bank_holiday_treatment: {presence: {allowEmpty: false}, },
            },
            formLabels: {
                'pay_schedule': 'Frequency',
                'check_date_offset_1': 'Check Date Offset',
                'check_date_offset_2': 'Second Check Date Offset',
            },
        }
    },
    watch: {
        'formData.pay_schedule'(o, n) {
            if (o != n) {
                this.formData.period_start = ''
                this.formData.pay_period_en = ''
                this.formData.check_date_offset_1 = ''
                this.formData.check_date_offset_2 = ''
                this.formData.weekend_treatment = ''
            }
        },
    },
    methods: {
        makeFormData() {
            return {
                name: this.initialValue.name ? this.initialValue.name : '',
                pay_schedule: this.initialValue.pay_schedule ? this.initialValue.pay_schedule : '',
                period_start: this.initialValue.period_start ? this.initialValue.period_start : '',
                period_end: this.initialValue.period_end ? this.initialValue.period_end : '',
                check_date_offset_1: this.initialValue.check_date_offset_1 ? this.initialValue.check_date_offset_1 : '',
                check_date_offset_2: this.initialValue.check_date_offset_2 ? this.initialValue.check_date_offset_2 : '',
                bank_holiday_treatment: this.initialValue.bank_holiday_treatment ? this.initialValue.bank_holiday_treatment : '',
                weekend_treatment: this.initialValue.weekend_treatment ? this.initialValue.weekend_treatment : '',
            }
        },
        getFormRules() {
            const rules = JSON.parse(JSON.stringify(this.formRules))

            if (['weekly', 'bi-weekly'].includes(this.formData.pay_schedule)) {
            }

            if (['semi-monthly'].includes(this.formData.pay_schedule)) {
                rules.period_end = {presence: {allowEmpty: false}, }
                rules.check_date_offset_2 = {presence: {allowEmpty: false}, }
                rules.weekend_treatment = {presence: {allowEmpty: false}, }
            }

            if (['monthly'].includes(this.formData.pay_schedule)) {
                rules.weekend_treatment = {presence: {allowEmpty: false}, }
            }

            return rules
        },
        setErrors(errors) {
            Object.assign(this.errors, errors)
        },
    },
}

</script>

